import { render, staticRenderFns } from "./AspacLoPresidentRegistrationCreate.vue?vue&type=template&id=6626e99d&scoped=true"
import script from "./AspacLoPresidentRegistrationCreate.vue?vue&type=script&lang=js"
export * from "./AspacLoPresidentRegistrationCreate.vue?vue&type=script&lang=js"
import style0 from "./AspacLoPresidentRegistrationCreate.vue?vue&type=style&index=0&id=6626e99d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6626e99d",
  null
  
)

export default component.exports